






















































































































































































































// 3rd party libs
import {
    mapActions,
    mapGetters,
} from 'vuex';

import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';
import chips from '@webapp/components/chips.vue';
import search from '@webapp/components/search.vue';

export default {
    name: 'partner-filter-component',
    components: {
        search,
        loadingSpinner,
        chips,
    },
    props: {
        contextKey: {
            type: String,
            default: null,
        },
        closeModal: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            pagination: 1,
            list: [],
            isScrollLoading: false,
            isLoading: true,
            searchText: '',
            searchedPartners: [],
            selectedPartners: [],
        };
    },
    computed: {
        ...mapGetters('partners', [
            'allSignedPartners',
            'getPartnersFiltered',
        ]),

        shouldButtonBeDisabled() {
            const partnersFiltered = this.getPartnersFiltered(this.contextKey);

            return this.selectedPartners?.length === partnersFiltered?.length &&
                this.selectedPartners?.every((partner) => partnersFiltered?.some((p) => p.id === partner.id));
        },

        isClearEnabled() {
            return this.selectedPartners?.length;
        },
    },
    mounted() {
        this.selectedPartners = [...(this.getPartnersFiltered(this.contextKey) || [])];
        this.search();
    },
    methods: {
        ...mapActions('partners', [
            'setPartnersFiltered',
            'clearPartnersFiltered',
        ]),

        onTextCleared() {
            this.isLoading = true;
            this.searchText = '';
            this.search(0);
        },

        onTextUpdated(text: string) {
            if (!text?.trim() || text?.trim() === this.searchText?.trim()) {

                return;
            }

            this.isLoading = true;
            this.searchText = text;

            if (text?.trim()) {
                this.searchedPartners = this.allSignedPartners.filter((partner) => {
                    const cleanText = this.clean(text);

                    return this.clean(partner.name).includes(cleanText) || this.clean(partner.shortName).includes(cleanText);
                });
            }
            this.search(0);
        },

        clearSelected() {
            if (!this.isClearEnabled) {

                return;
            }

            this.isLoading = true;
            this.selectedPartners = [];

            if (this.searchText && this.$refs.searchbar) {
                this.$refs.searchbar?.clearText();
            }
        },

        search(pagination: number) {
            if (pagination === 0) {
                this.list = [];
                this.pagination = 1;
            }

            let newIndex = 35,
                partnersPerPage = 25,
                partnersVisible = 25;

            if (this.pagination > 1) {
                partnersPerPage = 15;
                partnersVisible = 25 + (partnersPerPage * (this.pagination - 1));
                newIndex = partnersVisible + partnersPerPage;
            }

            const partnerSource = this.searchText ? this.searchedPartners : this.allSignedPartners;
            const maxSourceIndex = partnerSource.length;

            // We set a timeout to let the drawer appear before the "loading lag" occurs
            setTimeout(() => {
                this.list.push(...partnerSource.slice(this.list.length, newIndex <= maxSourceIndex ? newIndex : maxSourceIndex));
                this.isLoading = false;
                this.isScrollLoading = false;
            }, 800);
        },

        onScroll(e) {
            const partnerSource = this.searchText?.trim() ? this.searchedPartners : this.allSignedPartners;

            if (this.isScrollLoading || this.list.length === partnerSource.length) {
                return;
            }

            if (e.target.scrollHeight && e.target.scrollTop && e.target.scrollHeight - (e.target.clientHeight + e.target.scrollTop) <= 40) {
                this.isScrollLoading = true;
                this.search(++this.pagination);
            }
        },

        clean(str: string) {
            // Remove accents, spaces and special chars
            return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                .replace(/([^\w]+|\s+)/g, '')
                .toLowerCase();
        },

        onPartnerSelect(toSelectPartner) {
            const partnerAlreadyIn = this.selectedPartners.some((partner) => toSelectPartner.id === partner.id);

            if (partnerAlreadyIn) {
                this.removeSelected(toSelectPartner);
            } else {
                this.selectedPartners.push(toSelectPartner);
            }
        },

        removeSelected(toRemovePartner) {
            this.selectedPartners = this.selectedPartners.filter((partner) => partner.id !== toRemovePartner.id);
        },

        isPartnerSelected(partner) {
            return this.selectedPartners.some((selectedPartner) => selectedPartner.id === partner.id);
        },

        onValidate() {
            if (this.selectedPartners?.length) {
                this.setPartnersFiltered({
                    partners: this.selectedPartners,
                    contextKey: this.contextKey,
                });
            } else {
                this.clearPartnersFiltered(this.contextKey);
            }

            this.closeModal();
        },
    },
};
